import type { AxiosInstance } from 'axios';
import type { ApiResponse } from '@/types';
import type { ChangePasswordQuery } from '@/types/api/systemUser.type';
import type { SettingItem, UserItem } from '@/types/api/account.type';

export default function systemUserApi(ai: AxiosInstance) {
  /** 修改后台密码 */
  function changePassword<D extends ChangePasswordQuery, R extends ApiResponse<D>>(params: ChangePasswordQuery) {
    return ai.post<R>('/api/v2/sysUser/changePassword', params, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  function getCurrentUserInfo<D extends UserItem, R extends ApiResponse<D>>() {
    return ai.get<R>('/api/v2/sysUser/info');
  }

  function getSystemSetting<D extends SettingItem, R extends ApiResponse<D>>() {
    return ai.get<R>('/api/v2/sys/getSetting');
  }

  function updateSystemSetting<D extends SettingItem, R extends ApiResponse<D>>(params: SettingItem) {
    return ai.post<R>('/api/v2/sys/updateSetting', params);
  }

  return {
    changePassword,
    getCurrentUserInfo,
    getSystemSetting,
    updateSystemSetting
  };
}